import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "layout-main-container",
  style: {"position":"relative"}
}
const _hoisted_2 = { class: "accordion" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-angle-left",
  style: {"color":"white"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex align-items-center justify-content-between submenu-dropdown-text" }
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = { class: "menu-item-label" }
const _hoisted_9 = { class: "layout-main" }

import { computed, watch, ref, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';

import i18n from '@/locale/i18n';
import { useAuthStore } from '@/store/auth';
import { useLayout } from '@/utils/layout';

import AppFooter from './AppFooter.vue';
import SpinnerDialog from './components/common/SpinnerDialog.vue';
import AppMenuTopBar from './AppMenuTopBar.vue';
import AppSideBar from './AppSideBar.vue';
import router from './router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const t = i18n.global.t;
const route = useRoute();

const outsideClickListener = ref(null);

const { layoutConfig, layoutState, isSidebarActive } = useLayout();

const authStore = useAuthStore();

const layoutLeftbarSubmenu = ref();

const layoutLeftbarSubmenuShow = computed(() => {
    return layoutConfig.activeMenuItem.value !== 'DASHBOARD' && layoutConfig.activeMenuItem.value ? 'display: block' : '';
});

const sideBarClick = () => {
    const mainContainerEl = document.querySelector('.layout-main-container');
    mainContainerEl!.style!.paddingLeft = '270px';
    layoutLeftbarSubmenu.value.style.display = 'block';

    const menus = getCategoryMenus();
    if (menus && menus.length > 0) {
        menus.forEach((item, index) => {
            if (item.items && item.items.length > 0 && index === 0) {
                router.push({path: item.items[0].path});
            }
        })
    }
    
    const resizeEvent = new Event('resize'); 
    window.dispatchEvent(resizeEvent);  
}

const layoutLeftbarSubmenuClick = () => {
    // const mainContainerEl = document.querySelector('.layout-main-container');
    // mainContainerEl!.style!.paddingLeft = '70px';
    // layoutLeftbarSubmenu.value.style.display = 'none';
    // const resizeEvent = new Event('resize'); 
    // window.dispatchEvent(resizeEvent);  
}

onMounted(() => {
    if (layoutConfig.activeMenuItem.value === 'ダッシュボード') {
        const mainContainerEl = document.querySelector('.layout-main-container');
        if (mainContainerEl) {
            mainContainerEl!.style!.paddingLeft = '70px';
        }
    } else {
        const mainContainerEl = document.querySelector('.layout-main-container');
        if (layoutConfig.activeMenuItem.value) {
            if (mainContainerEl) {
                mainContainerEl!.style!.paddingLeft = '270px';
            }
        } else {
            if (mainContainerEl) {
                mainContainerEl!.style!.paddingLeft = '70px';
            }
        }
    }
    bindOutsideClickListener();
});

onBeforeUnmount(() => {
    unbindOutsideClickListener();
    layoutConfig.activeMenuItem.value = null;
});

watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});

// watch(layoutConfig.activeMenuItem, (newVal) => {
//     if (newVal === 'DASHBOARD') {
//         const mainContainerEl = document.querySelector('.layout-main-container');
//         if (mainContainerEl) {
//             mainContainerEl!.style!.paddingLeft = '70px';
//         }
//     } else {
//         const mainContainerEl = document.querySelector('.layout-main-container');
//         if (mainContainerEl) {
//             mainContainerEl!.style!.paddingLeft = '270px';
//         }
//     }
// });

const clickDropRoute = (categoryClass: string) => {
    const routeEl = document.getElementById(categoryClass + 'sub');
    if (routeEl && routeEl!.style!.display !== 'none') {
        routeEl!.style!.display = 'none';
    } else if (routeEl && routeEl!.style!.display !== 'block') {
        routeEl!.style!.display = 'block';
    }
}

const clickCloseRoute = () => {
    const mainContainerEl = document.querySelector('.layout-main-container');
    mainContainerEl!.style!.paddingLeft = '70px';
    layoutLeftbarSubmenu.value.style.display = 'none';
    const resizeEvent = new Event('resize'); 
    window.dispatchEvent(resizeEvent);  
}

const getCategoryMenus = () => {
    let menus: any[] = [];
    let menuCategorys: any[] = [];
    if (layoutConfig.activeMenuItem.value !== 'MASTER') {
        authStore.menus?.forEach((item: any) => {
            if (item.category === layoutConfig.activeMenuItem.value) {
                menus = item.items;
            }
        });
        if (layoutConfig.activeMenuItem.value === '帳票') {
            menus.forEach(item => {
                const find = menuCategorys.find(categoryMenu => categoryMenu.category === item.subCategory);
                if (find) {
                    find.items.push(item)
                } else {
                    menuCategorys.push({ category: item.subCategory, items: [item] });
                }
            })
        } else {
            if (menus.length > 0) {
                menus.forEach(item => {
                    if (menuCategorys.length < 1) {
                        menuCategorys.push({ category: item.category, items: [item] });
                    } else {
                        menuCategorys[0].items.push(item)
                    }
                })
            }
        }
    } else {
        authStore.menus?.forEach((item: any) => {
            if (item.section === 'SECTION02') {
                if (item.items && item.items.length > 0) {
                    item.items.forEach((menu: any) => {
                        if (menu.path) {
                            menus.push(menu);
                        }
                    })
                }
            }
        });
        if (menus.length > 0) {
            menus.forEach(item => {
                const find = menuCategorys.find(categoryMenu => categoryMenu.category === item.category);
                if (find) {
                    find.items.push(item)
                } else {
                    menuCategorys.push({ category: item.category, items: [item] });
                }
            })
        }
    }

    return menuCategorys;
}

const containerClass = computed(() => {
    return {
        // 'layout-theme-light': layoutConfig.darkTheme.value === 'light',
        // 'layout-theme-dark': layoutConfig.darkTheme.value === 'dark',
        'layout-overlay': layoutConfig.menuMode.value === 'overlay',
        'layout-static': layoutConfig.menuMode.value === 'static',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive.value && layoutConfig.menuMode.value === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive.value,
        'layout-mobile-active': layoutState.staticMenuMobileActive.value,
        'p-input-filled': layoutConfig.inputStyle.value === 'filled',
        'p-ripple-disabled': !layoutConfig.ripple.value
    };
});

const bindOutsideClickListener = () => {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event: any) => {
            if (isOutsideClicked(event)) {
                layoutState.leftbarMenuVisible.value = false;
                layoutState.overlayMenuActive.value = false;
                layoutState.staticMenuMobileActive.value = false;
                layoutState.menuHoverActive.value = false;
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
};
const unbindOutsideClickListener = () => {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener.value = null;
    }
};
const isOutsideClicked = (event: any) => {
    const sidebarEl = document.querySelector('.layout-leftbar-sidebar');
    if (sidebarEl) {
        return !(sidebarEl!.isSameNode(event.target) || sidebarEl!.contains(event.target));
    }
    // const topbarEl = document.querySelector('.layout-menu-button');

    // return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
};

// export default {
//     emits: ['change-theme'],
//     data() {
//         const { isSidebarActive, layoutState } = useLayout();
//         return {
//             layoutMode: 'static',
//             staticMenuInactive: false,
//             overlayMenuActive: false,
//             mobileMenuActive: false,
//             isSidebarActive,
//             outsideClickListener: null,
//             layoutState
//         }
//     },
//     watch: {
//         $route() {
//             this.menuActive = false;
//             this.$toast.removeAllGroups();
//         },
//         isSidebarActive(newVal) {
//             if (newVal) {
//                 this.bindOutsideClickListener();
//             } else {
//                 this.unbindOutsideClickListener();
//             }
//         }
//     },
//     unmounted() {
//     },
//     mounted() {
//     },
//     methods: {
//         bindOutsideClickListener() {
//             if (!this.outsideClickListener) {
//                 this.outsideClickListener = (event) => {
//                     if (this.isOutsideClicked(event)) {
//                         this.layoutState.overlayMenuActive = false;
//                         this.layoutState.staticMenuMobileActive = false;
//                         this.layoutState.menuHoverActive = false;
//                     }
//                 };
//                 document.addEventListener('click', this.outsideClickListener);
//             }
//         },
//         unbindOutsideClickListener() {
//             if (this.outsideClickListener) {
//                 document.removeEventListener('click', this.outsideClickListener);
//                 this.outsideClickListener = null;
//             }
//         },
//         isOutsideClicked(event) {
//             const sidebarEl = document.querySelector('.layout-sidebar');
//             const topbarEl = document.querySelector('.layout-menu-button');

//             return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
//         },
//         onWrapperClick() {
//             if (!this.menuClick) {
//                 this.overlayMenuActive = false;
//                 this.mobileMenuActive = false;
//             }

//             this.menuClick = false;
//         },
//         onMenuToggle() {
//             this.menuClick = true;

//             if (this.isDesktop()) {
//                 if (this.layoutMode === 'overlay') {
//                     if (this.mobileMenuActive === true) {
//                         this.overlayMenuActive = true;
//                     }

//                     this.overlayMenuActive = !this.overlayMenuActive;
//                     this.mobileMenuActive = false;
//                 }
//                 else if (this.layoutMode === 'static') {
//                     this.staticMenuInactive = !this.staticMenuInactive;
//                 }
//             }
//             else {
//                 this.mobileMenuActive = !this.mobileMenuActive;
//             }

//             event.preventDefault();
//         },
//         onSidebarClick() {
//             this.menuClick = true;
//         },
//         onMenuItemClick(event) {
//             if (event.item && !event.item.items) {
//                 this.overlayMenuActive = false;
//                 this.mobileMenuActive = false;
//             }
//         },
//         onLayoutChange(layoutMode) {
//             this.layoutMode = layoutMode;
//         },
//         addClass(element, className) {
//             if (element.classList)
//                 element.classList.add(className);
//             else
//                 element.className += ' ' + className;
//         },
//         removeClass(element, className) {
//             if (element.classList)
//                 element.classList.remove(className);
//             else
//                 element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
//         },
//         isDesktop() {
//             return window.innerWidth >= 992;
//         },
//         isSidebarVisible() {
//             if (this.isDesktop()) {
//                 if (this.layoutMode === 'static')
//                     return !this.staticMenuInactive;
//                 else if (this.layoutMode === 'overlay')
//                     return this.overlayMenuActive;
//             }

//             return true;
//         }
//     },
//     computed: {
//         containerClass() {
//             return ['layout-wrapper', {
//                 'layout-overlay': this.layoutMode === 'overlay',
//                 'layout-static': this.layoutMode === 'static',
//                 'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
//                 'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
//                 'layout-mobile-sidebar-active': this.mobileMenuActive,
//                 'p-input-filled': this.$primevue.config.inputStyle === 'filled',
//                 'p-ripple-disabled': this.$primevue.config.ripple === false
//             }];
//         },
//         logo() {
//             return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
//         },
//         menu() {
//             let authStore = useAuthStore();
//             return authStore.menus ? authStore.menus : [];
//         }
//     },
//     beforeUpdate() {
//         if (this.mobileMenuActive)
//             this.addClass(document.body, 'body-overflow-hidden');
//         else
//             this.removeClass(document.body, 'body-overflow-hidden');
//     },
//     components: {
//         // "AppTopBar": AppTopBar,
//         // "AppMenu": AppMenu,
//         // "AppConfig": AppConfig,
//         "AppFooter": AppFooter,
//         // "LocaleDropdown": LocaleDropdown,
//         SpinnerDialog,
//         'AppMenuTopBar': AppMenuTopBar,
//         'AppSideBar': AppSideBar
//     }
// }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(containerClass))
  }, [
    _createVNode(AppMenuTopBar),
    _createVNode(AppSideBar, { onSideBarClick: sideBarClick }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "layout-leftbar-submenu",
        ref_key: "layoutLeftbarSubmenu",
        ref: layoutLeftbarSubmenu,
        style: {"position":"fixed","display":"none"}
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "flex align-items-center justify-content-end" }, [
            _createElementVNode("div", {
              onClick: clickCloseRoute,
              style: {"padding":"0","min-height":"18.2px","min-width":"26px","background":"black","border-radius":"6px","text-align":"center","margin-left":"35px","line-height":"18.2px"}
            }, _hoisted_4)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCategoryMenus(), (item) => {
            return (_openBlock(), _createElementBlock("div", { key: item }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, _toDisplayString(item.category), 1)
              ]),
              _createElementVNode("div", {
                id: (item.category + 'sub')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (sub) => {
                  return (_openBlock(), _createElementBlock("div", { key: sub }, [
                    (sub.visible === 1)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: sub.path,
                          onClick: layoutLeftbarSubmenuClick
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)(sub.label)), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 8, _hoisted_6)
            ]))
          }), 128))
        ])
      ], 512),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(AppFooter)
    ]),
    _createVNode(SpinnerDialog)
  ], 2))
}
}

})